function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_629_1842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 3.57628e-07H28.5V28H0.5V3.57628e-07Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_629_1842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0264 14.0001C27.0264 20.9183 21.4183 26.5264 14.5001 26.5264C7.5826 26.5264 1.97375 20.9183 1.97375 14.0001C1.97375 7.08258 7.5826 1.47374 14.5001 1.47374C21.4183 1.47374 27.0264 7.08258 27.0264 14.0001Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3784 17.4103C21.315 17.3532 21.2336 17.3198 21.1483 17.3159C21.063 17.312 20.979 17.3378 20.9105 17.389C20.8818 17.4103 18.0206 19.5258 14.5 19.5258C10.9882 19.5258 8.11749 17.4103 8.08949 17.389C8.02118 17.3377 7.93716 17.3117 7.85181 17.3155C7.76647 17.3194 7.68511 17.3527 7.62165 17.4099C7.55819 17.4671 7.51658 17.5446 7.50394 17.6291C7.49129 17.7135 7.5084 17.7998 7.55234 17.8731C7.64739 18.0315 9.92276 21.7363 14.5 21.7363C19.0773 21.7363 21.3534 18.0315 21.4477 17.8731C21.4917 17.7999 21.5088 17.7137 21.4962 17.6293C21.4835 17.5448 21.4419 17.4674 21.3784 17.4103Z",
    fill: "#140B29",
    style: {
      fill: "#140B29",
      fill: "color(display-p3 0.0784 0.0431 0.1608)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5 5.89445C9.61699 5.89445 5.65794 5.47666 5.65794 4.05235C5.65794 2.62803 9.61699 2.21024 14.5 2.21024C19.3831 2.21024 23.3421 2.62803 23.3421 4.05235C23.3421 5.47666 19.3831 5.89445 14.5 5.89445ZM14.5 0.73656C7.98931 0.73656 2.71057 1.97888 2.71057 4.42077C2.71057 6.86193 7.98931 8.10498 14.5 8.10498C21.0108 8.10498 26.2895 6.86193 26.2895 4.42077C26.2895 1.97888 21.0108 0.73656 14.5 0.73656Z",
    fill: "url(#paint0_linear_629_1842)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.88159 5.20312C6.37854 4.22755 7.03948 3.73607 8.83591 2.82313C10.591 1.93263 12.5319 1.47007 14.5 1.47323C16.6317 1.47323 18.6381 2.00523 20.3955 2.9447C20.9076 3.21881 21.4506 3.59681 21.9605 3.93649",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.3948 14.7372C20.2402 14.7372 20.0895 14.6885 19.9641 14.598C19.8387 14.5076 19.745 14.3799 19.6963 14.2332C19.5467 13.7918 18.9454 12.5267 18.1843 12.5267C17.4017 12.5267 16.7924 13.8729 16.6723 14.2332C16.642 14.3251 16.5938 14.4101 16.5305 14.4833C16.4672 14.5566 16.39 14.6165 16.3035 14.6598C16.2169 14.7031 16.1226 14.7288 16.0261 14.7355C15.9295 14.7422 15.8326 14.7298 15.7409 14.6989C15.6491 14.6684 15.5642 14.6201 15.4911 14.5568C15.418 14.4935 15.3581 14.4163 15.3148 14.3298C15.2715 14.2433 15.2458 14.1491 15.239 14.0526C15.2322 13.9561 15.2445 13.8592 15.2752 13.7675C15.3673 13.4897 16.2353 11.053 18.1843 11.053C20.1332 11.053 21.0012 13.4897 21.0933 13.7675C21.1305 13.8782 21.1408 13.9962 21.1234 14.1117C21.1059 14.2272 21.0612 14.3369 20.9929 14.4316C20.9247 14.5264 20.8348 14.6036 20.7308 14.6567C20.6268 14.7098 20.5116 14.7374 20.3948 14.7372ZM13.0264 14.7372C12.7176 14.7372 12.4303 14.5419 12.3271 14.2332C12.1775 13.7918 11.5777 12.5267 10.8158 12.5267C10.0333 12.5267 9.42468 13.8729 9.30458 14.2332C9.27411 14.3251 9.2258 14.41 9.16242 14.4832C9.09904 14.5564 9.02183 14.6163 8.93523 14.6596C8.84863 14.7029 8.75434 14.7286 8.65777 14.7353C8.5612 14.7421 8.46424 14.7297 8.37247 14.6989C8.28066 14.6684 8.19575 14.6201 8.12261 14.5568C8.04947 14.4935 7.98953 14.4164 7.94621 14.3299C7.90289 14.2434 7.87705 14.1492 7.87016 14.0527C7.86327 13.9562 7.87546 13.8593 7.90605 13.7675C7.99889 13.4897 8.86689 11.053 10.8158 11.053C12.7648 11.053 13.6328 13.4897 13.7256 13.7675C13.7627 13.8783 13.7729 13.9963 13.7553 14.1118C13.7377 14.2272 13.6929 14.3369 13.6246 14.4316C13.5563 14.5264 13.4664 14.6035 13.3624 14.6566C13.2584 14.7098 13.1432 14.7374 13.0264 14.7372Z",
    fill: "#140B29",
    style: {
      fill: "#140B29",
      fill: "color(display-p3 0.0784 0.0431 0.1608)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_629_1842",
    x1: 2.71057,
    y1: 4.42077,
    x2: 26.2895,
    y2: 4.42077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#765EAC",
    style: {
      stopColor: "#765EAC",
      stopColor: "color(display-p3 0.4629 0.3687 0.6740)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D54D7",
    style: {
      stopColor: "#7D54D7",
      stopColor: "color(display-p3 0.4888 0.3300 0.8448)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngel);
export default __webpack_public_path__ + "static/media/angel.9dfb3e7d42967e836eed1947aa84a363.svg";
export { ForwardRef as ReactComponent };